import React from 'react'
import { Typeahead } from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'

const FormChips = ({
  placeholder,
  onChangeVal,
  options,
  dispField,
  valField,
  control,
  ...rest
}) => {
  return (
    <Typeahead
      id='multiple'
      clearButton
      multiple
      selectHintOnEnter
      options={options}
      labelKey={dispField}
      placeholder={placeholder}
      selected={control}
      flip={true}
      onChange={e => onChangeVal(e)}
    />
  )
}

export default FormChips
